import Initial_State from './Initial_State';
import * as ActionTypes from './Actions';

export const chatReducer = (state = Initial_State, action) => {
    switch (action.type) {
        case ActionTypes.SET_ROOMS:
            return {
                ...state,
                rooms: action.payload,
                loading: false
            };

        case ActionTypes.ADD_ROOM:
            return {
                ...state,
                rooms: [action.payload, ...state.rooms]
            };

        case ActionTypes.SET_ACTIVE_ROOM:
            return {
                ...state,
                activeRoom: action.payload
            };

        case ActionTypes.SET_MESSAGES:
            return {
                ...state,
                messages: {
                    ...state.messages,
                    [action.payload.roomId]: action.payload.messages
                }
            };

        case ActionTypes.ADD_MESSAGE:
            const { room_id } = action.payload;
            const currentMessages = state.messages[room_id] || [];
            
            return {
                ...state,
                messages: {
                    ...state.messages,
                    [room_id]: [...currentMessages, action.payload]
                },
                // Update room's last message
                rooms: state.rooms.map(room => 
                    room.room_id === room_id
                        ? {
                            ...room,
                            last_message: action.payload.message_content,
                            last_message_time: action.payload.timestamp
                        }
                        : room
                )
            };

        case ActionTypes.SET_TYPING:
            const { roomId, userId, userName, isTyping } = action.payload;
            const roomTyping = state.typingUsers[roomId] || {};
            
            if (isTyping) {
                return {
                    ...state,
                    typingUsers: {
                        ...state.typingUsers,
                        [roomId]: {
                            ...roomTyping,
                            [userId]: userName
                        }
                    }
                };
            } else {
                const { [userId]: removed, ...rest } = roomTyping;
                return {
                    ...state,
                    typingUsers: {
                        ...state.typingUsers,
                        [roomId]: rest
                    }
                };
            }

        case ActionTypes.SET_UNREAD_COUNT:
            return {
                ...state,
                unreadCounts: {
                    ...state.unreadCounts,
                    [action.payload.roomId]: action.payload.count
                },
                rooms: state.rooms.map(room =>
                    room.room_id === action.payload.roomId
                        ? { ...room, unread_count: action.payload.count }
                        : room
                )
            };

        case ActionTypes.CLEAR_UNREAD:
            return {
                ...state,
                unreadCounts: {
                    ...state.unreadCounts,
                    [action.payload]: 0
                },
                rooms: state.rooms.map(room =>
                    room.room_id === action.payload
                        ? { ...room, unread_count: 0 }
                        : room
                )
            };

        case ActionTypes.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ActionTypes.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ActionTypes.RESET_CHAT:
            return Initial_State;

        default:
            return state;
    }
};

export default chatReducer;
